import { TenantFormTabs } from 'src/features/tenants/types/tenantForm.types';

export const TENANT_FORM_TABS: Record<TenantFormTabs, string> = {
  initialData: 'Dados iniciais',
  settings: 'Secrets/Variáveis',
  domains: 'Domínios',
};
